'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = I18nify;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function I18nify(Component) {
    var I18nifyWrapper = function (_React$Component) {
        (0, _inherits3.default)(I18nifyWrapper, _React$Component);

        function I18nifyWrapper(props, context) {
            (0, _classCallCheck3.default)(this, I18nifyWrapper);
            return (0, _possibleConstructorReturn3.default)(this, (I18nifyWrapper.__proto__ || (0, _getPrototypeOf2.default)(I18nifyWrapper)).call(this, props, context));
        }

        (0, _createClass3.default)(I18nifyWrapper, [{
            key: 'isStateless',
            value: function isStateless() {
                return !Component.prototype.render;
            }
        }, {
            key: 'render',
            value: function render() {
                var refProp = this.isStateless() ? {} : {
                    ref: 'component'
                };

                return _react2.default.createElement(Component, (0, _extends3.default)({}, this.props, {
                    i18n: this.context.i18n,
                    numberFormatUtils: this.context.numberFormatUtils,
                    availabilityPrinter: this.context.availabilityPrinter,
                    moment: this.context.moment
                }, refProp));
            }
        }]);
        return I18nifyWrapper;
    }(_react2.default.Component);

    I18nifyWrapper.displayName = 'I18nifyWrapper(' + (Component.displayName || 'Component') + ')';

    I18nifyWrapper.contextTypes = {
        i18n: _propTypes2.default.object,
        numberFormatUtils: _propTypes2.default.object,
        availabilityPrinter: _propTypes2.default.object,
        moment: _propTypes2.default.func
    };

    return I18nifyWrapper;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-components/dist/shared/I18nify/index.js
// module id = 111
// module chunks = 0